export default {
  ASSIGNED: 'ASSIGNED',
  STOCKED: 'STOCKED',
  PICKED_UP: 'PICKED_UP',
  REMOVE_RX: 'REMOVE_RX',
  VERFIY_RX: 'VERFIY_RX',
  RX_HOLD: 'RX_HOLD'
};
